module.exports = __webpack_public_path__ + "img/VIPBg.67499c0a.png";